import {createTheme} from "@mui/material";

const PRIMARY = '#a34d88';
const BG = '#171717';

const theme = createTheme({
    palette: {
        primary: {
            main: PRIMARY,
            contrastText: BG
        },
        text: {
            primary: PRIMARY
        },
        background: {
            paper: BG
        }
    },
    typography: {
        fontFamily: 'Circe,Arial,sans-serif',
        body1: {
            fontSize: 18,
            letterSpacing: '1px'
        }
    },
    components: {
        MuiRadio: {
            styleOverrides: {
                root: {
                    "color": PRIMARY,
                    '&.Mui-checked': {
                        color: '#fff'
                    }
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: '#fff'
                    }
                }
            }
        }
    }
});

export default theme;
